//DBTables

import { ModuleTypeId } from "../../types/DBTables";
import { UseFormReturn } from "react-hook-form";
import RoundByggnadsData from "./Editors/RoundByggnadsData";
import RoundVarmeSekundar from "./Editors/RoundVarmeSekundar";
import { IModuleRound } from "../../modules/roundHandler";
import RoundLokalerOchRum from "./Editors/RoundLokalerOchRum";
import RoundVarmePrimarFjarr from "./Editors/RoundVarmePrimarFjarr";
import RoundVarmePrimarPump from "./Editors/RoundVarmePrimarPump";
import RoundDirektverkandeEL from "./Editors/RoundDirektverkandeEL";
import RoundVentilationFTX from "./Editors/RoundVentilationFTX";
import RoundKylaVattenburet from "./Editors/RoundKylaVattenburet";
import RoundKylmaskin from "./Editors/RoundKylmaskin";
import RoundVentilationFXochF from "./Editors/RoundVentilationFXochF";
import RoundVentilationS from "./Editors/RoundVentilationS";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
  configurationData: any;
}

const ModuleRoundEditor = ({ module, formHook, configurationData }: IProps) => {
  const getModuleTypeConfigurator = (module: IModuleRound) => {
    switch (module?.moduleTypeId) {
      case ModuleTypeId.Byggnadsdata:
        return <RoundByggnadsData module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.Lokaler:
        return <RoundLokalerOchRum module={module} formHook={formHook} data={configurationData} />;

      //Värme
      case ModuleTypeId.VarmePrimarFjarr:
        return <RoundVarmePrimarFjarr module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmePrimarPump:
        return <RoundVarmePrimarPump module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeSekundarVatten:
        return <RoundVarmeSekundar module={module} formHook={formHook} data={configurationData} />;

      case ModuleTypeId.VarmeElVarmepump:
        return <RoundDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElStralningsvarmare:
        return <RoundDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElGolvvarme:
        return <RoundDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElAirotemper:
        return <RoundDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VarmeElRadiatorer:
        return <RoundDirektverkandeEL module={module} formHook={formHook} data={configurationData} />;
      //Ventilation
      case ModuleTypeId.VentilationFTX:
        return <RoundVentilationFTX module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VentilationFT:
        return <RoundVentilationFTX module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VentilationFX:
        return <RoundVentilationFXochF module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VentilationF:
        return <RoundVentilationFXochF module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.VentilationS:
        return <RoundVentilationS module={module} formHook={formHook} data={configurationData} />;
      //Kyla
      case ModuleTypeId.KylaVattenburet:
        return <RoundKylaVattenburet module={module} formHook={formHook} data={configurationData} />;
      case ModuleTypeId.KylaMaskin:
        return <RoundKylmaskin module={module} formHook={formHook} data={configurationData} />;
      default:
        return <>Not yet implemented</>;
    }
  };

  return <>{getModuleTypeConfigurator(module)}</>;
};

export default ModuleRoundEditor;
